module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/border-battle.ad7344ea.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/border-battle.png
// module id = 2534
// module chunks = 11